const DEFAULT_POSITION = { x: 100, y: 100 };

export default DEFAULT_POSITION;
